// ACCORDIONS
document.addEventListener('DOMContentLoaded', function() {
  const accordionGroups = document.querySelectorAll('.c-accordions');
  if(accordionGroups.length > 0){
    accordionGroups.forEach(accordionGroup => {
      let accordions = gsap.utils.toArray('.c-accordion', accordionGroup),
          triggers = gsap.utils.toArray('.c-accordion-trigger', accordionGroup),
          accordionToggles = accordions.map(initAccordion);

      triggers.forEach(trigger => {
        trigger.addEventListener('click', () => toggleAccordion(trigger));
      });

      function toggleAccordion(clickedAccordion){    
        accordionToggles.forEach(toggleFn => toggleFn(clickedAccordion))

        
        accordions.forEach((accordion, index) => {
          if(clickedAccordion=== accordion.querySelector('.c-accordion-trigger')){
            accordion.classList.add('open');
          } else{
            accordion.classList.remove('open');
          }
        });
      }

      function initAccordion(element){
        let trigger = element.querySelector('.c-accordion-trigger'),
            content = element.querySelector('.c-accordion-content'),
            icon = element.querySelector('.c-accordion-icon');
        
        gsap.set(content, { height: 'auto' });
        
        let contentAnimation = gsap.from(content, { 
          height: 0,
          paddingTop: '0em',
          paddingBottom: '0em',
          duration: 0.5, 
          ease: 'power1.inOut'
        }).reverse();

        let iconAnimation = gsap.to(icon, { 
          rotation: 135,
          duration: 0.5, 
          ease: 'power1.inOut'
        }).reverse();

        if(element.classList.contains('open')){
          contentAnimation.play();
          iconAnimation.play();
        }
        
        return function(clickedAccordion){ 
          if(clickedAccordion === trigger){
            contentAnimation.reversed(!contentAnimation.reversed());
            iconAnimation.reversed(!iconAnimation.reversed());
          } else {
            contentAnimation.reverse();
            iconAnimation.reverse();
          }
        }
      }
    });
  }



  if(document.querySelectorAll('.c-tabs-wrap').length > 0){
    document.querySelectorAll('.c-tabs-wrap').forEach(tabsWrap => {
      tabsWrap.classList.add('init');
    });
  }
});